import {Text, Box} from '@chakra-ui/layout'
import React from 'react'
import {remCalc} from './../../../overrides/app/theme/_utils'
import {useCustomTheme} from '../../../overrides/app/context/theme'

function CoverPage() {
    const {theme} = useCustomTheme()
    return (
        <Box bg={'button.background.primary-default'} minHeight={'100%'} alignContent="center">
            <Box padding={remCalc(40)} minHeight="100vh">
                <Text textStyle="display-large" color="white" paddingBottom={remCalc(40)}>
                    {theme.label}
                    <br />
                    Design System
                </Text>
                <Text textStyle="head-medium" color="white">
                    component library
                </Text>
            </Box>
        </Box>
    )
}

export default CoverPage
